import * as React from "react";
function SvgCake(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21 12.21V9.207a2 2 0 00-2-2H5a2 2 0 00-2 2v12h18V12.21zm-2 2.854a3.36 3.36 0 01-1 .144c-1.319 0-2.29-.644-2.903-1.24-.621.661-1.615 1.24-3.097 1.24-1.487 0-2.482-.583-3.104-1.246-.61.592-1.584 1.246-2.896 1.246-.364 0-.697-.05-1-.147v4.147h14v-4.144zM5 12.187a1.512 1.512 0 00.02.155c.022.124.064.274.134.413a.794.794 0 00.261.31c.1.067.272.143.585.143.621 0 1.133-.313 1.533-.71a3.714 3.714 0 00.579-.75l.002-.004v.001l-.001.002v.002l1.855.216h.002v-.003l-.002-.004-.001-.005v-.002l.006.022c.01.026.026.072.053.131.055.12.147.283.29.446.26.298.742.658 1.684.658s1.424-.36 1.685-.658a1.864 1.864 0 00.342-.577l.007-.022v.002l-.002.005-.001.004v.002l.001.001 1.86-.204h.002l.021.037a3.557 3.557 0 00.542.703c.391.391.902.707 1.543.707.325 0 .502-.078.602-.144a.758.758 0 00.254-.303 1.464 1.464 0 00.143-.538l.001-.024V9.21H5v2.978zm10.894-.427c0-.002-.001-.003-.002-.003l.001.002.001.001zM17 5.208c-.068 0-.15-.007-.241-.02-1.369-.195-1.35-1.593-.583-2.743l.408-.613a.5.5 0 01.832 0l.408.613c.767 1.15.785 2.548-.583 2.743-.09.013-.173.02-.241.02zm-5.242-.02c.092.013.174.02.242.02s.15-.007.242-.02c1.367-.195 1.349-1.593.582-2.743l-.408-.613a.5.5 0 00-.832 0l-.408.613c-.767 1.15-.786 2.548.582 2.743zM7 5.208c-.068 0-.15-.007-.241-.02-1.369-.195-1.35-1.593-.583-2.743l.408-.613a.5.5 0 01.832 0l.408.613c.767 1.15.786 2.548-.583 2.743-.09.013-.173.02-.241.02z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgCake);
export default ForwardRef;
